import { j as o } from "../../../../jsx-runtime-B6kdoens.js";
import { forwardRef as r } from "react";
import { I as i } from "../../../../IconBase-CxZyIWw2.js";
const l = r((e, a) => /* @__PURE__ */ o.jsx(
  i,
  {
    ref: a,
    ...e,
    image: (s) => /* @__PURE__ */ o.jsx(
      "svg",
      {
        xmlns: "http://www.w3.org/2000/svg",
        width: 16,
        height: 16,
        fill: "none",
        viewBox: "0 0 16 16",
        ...s,
        children: /* @__PURE__ */ o.jsx(
          "path",
          {
            fill: "currentColor",
            fillRule: "evenodd",
            d: "M11.46 2.295a1.005 1.005 0 0 0-.664-1.256c-.53-.163-.964.164-1.256.665C8.5 3.49 6.5 5.99 3 5.99c0 0-.222.011-1 .011a1 1 0 0 0-1 1v7a1 1 0 0 0 1 1h10.465a1.91 1.91 0 0 0 1.682-.973C14.733 12.971 16 10.314 16 7a1 1 0 0 0-1-1h-3.325a1 1 0 0 1-.956-1.294zM5 13H3V8h2z",
            clipRule: "evenodd"
          }
        )
      }
    )
  }
));
l.displayName = "ThumbsUpIcon";
export {
  l as ThumbsUpIcon,
  l as default
};
//# sourceMappingURL=index.js.map
